import React from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import Icon from '../../../Icon';
import { COLORS } from '../../../../constants/styles';

import styles from './styles.styl';

function MediaIndicator({ noVideo, noAudio, pinned, className }) {
  return (
    <div className={cn(styles.root, className)}>
      {pinned && <Icon name="pin" size={12} style={{ fill: COLORS.white }} />}
      {noVideo && <Icon name="video-off" size={12} />}
      {noAudio && <Icon name="mute" size={12} />}
    </div>
  );
}

MediaIndicator.propTypes = {
  noVideo: PropTypes.bool,
  noAudio: PropTypes.bool,
  pinned: PropTypes.bool,
  className: PropTypes.string,
};

export default MediaIndicator;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MediaIndicator/index.jsx